import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=3754a064&scoped=true&lang=pug"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754a064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3754a064')) {
      api.createRecord('3754a064', component.options)
    } else {
      api.reload('3754a064', component.options)
    }
    module.hot.accept("./CheckboxInput.vue?vue&type=template&id=3754a064&scoped=true&lang=pug", function () {
      api.rerender('3754a064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/CheckboxInput.vue"
export default component.exports